import type { RgbPalette } from './types';

export const rgbEmojiPalette: RgbPalette = {
  id: 'rgb-emoji',
  name: 'RGB Emoji',
  type: 'rgb',
  levels: 3,
  rgbMap: {
    '0-0-0': '\u26AB',
    '2-2-2': '\u26AA',
    '1-1-1': '\u26BD',
    '1-0-0': '\u2648',
    '2-0-0': '\u2648',
    '2-1-0': '\u264A',
    '2-2-0': '\u264B',
    '2-2-1': '\u264C',
    '0-2-0': '\u264D',
    '1-2-0': '\u264D',
    '1-2-1': '\u264D',
    '0-1-0': '\u264E',
    '1-1-0': '\u264E',
    '0-1-1': '\u264F',
    '0-2-1': '\u264F',
    '0-0-1': '\u2650',
    '0-0-2': '\u2650',
    '0-1-2': '\u2650',
    '0-2-2': '\u2650',
    '1-2-2': '\u2650',
    '1-0-2': '\u2651',
    '1-1-2': '\u2651',
    '1-0-1': '\u2652',
    '2-0-2': '\u2652',
    '2-0-1': '\u2653',
    '2-1-1': '\u2653',
    '2-1-2': '\u2653',
  },
  fallback: '\u26AA',
};
